// Fallback page if someone is redirected to /signin/sent (older bundles or
// external links). The current SignIn flow handles email + code in-page, so
// most users never see this. Kept simple and free of dev jargon.

import { Link, useSearchParams } from "react-router-dom";
import { Mail } from "lucide-react";
import { Card, CardBody } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Wordmark } from "../components/Brand";

export function CheckEmail() {
  const [params] = useSearchParams();
  const email = params.get("email") ?? "your inbox";

  return (
    <div className="min-h-full flex flex-col">
      <header className="border-b border-border bg-surface">
        <div className="mx-auto max-w-5xl px-5 h-14 flex items-center">
          <Link to="/" className="block"><Wordmark size="sm" /></Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-10">
        <Card className="w-full max-w-md">
          <CardBody>
            <div className="h-11 w-11 rounded-xl bg-primary-soft border border-primary/15 flex items-center justify-center mb-3">
              <Mail className="h-5 w-5 text-primary" />
            </div>
            <h1 className="text-2xl font-semibold tracking-tight">Check your email</h1>
            <p className="mt-2 text-text-muted">
              We sent a sign-in link and a 6-digit code to <span className="font-medium text-text">{email}</span>. Either one signs you in. Both expire in 15 minutes.
            </p>
            <p className="mt-4 text-sm text-text-muted">
              Don't see it in a minute? Check your spam folder. Gmail sometimes hides new senders there.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              <Link to="/signin">
                <Button>Enter code instead</Button>
              </Link>
              <Link to="/signin">
                <Button variant="secondary">Use a different email</Button>
              </Link>
            </div>
          </CardBody>
        </Card>
      </main>
    </div>
  );
}
